(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.administradors.controller:AdministradorsCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.administradors')
    .controller('EntitatsAdministradorsCtrl', EntitatsAdministradorsCtrl);

  function EntitatsAdministradorsCtrl($translate, EntitatFactory, entitatData ,  Notification, $stateParams, $rootScope, UsuariFactory,$state,HelperFactory, $window) {
    var vm = this;
    vm.ctrlName = 'EntitatsAdministradorsCtrl';
    vm.personesAdministradors = [];
    vm.persones = [];
    vm.entitat= entitatData.data;
    vm.readonlychips=true;
    vm.viewuser=viewuser;
    vm.onEnviarAdminsChange=onEnviarAdminsChange;
    vm.listnotificar=[];


    vm.listnotificar = [{id:0, name: $translate.instant('enviar_all_users')},
                    {id:1, name: $translate.instant('enviar_admins')}];

    vm.entitat.tipusnotificacions=vm.listnotificar[vm.entitat.tipusnotificacions];


   if (angular.isUndefined($stateParams.idEntitat) || $stateParams.idEntitat === null || !$stateParams.idEntitat) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
    else { 
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }   

    function viewuser(id) {
      HelperFactory.setParams($stateParams, {'idUsuari': id});
        var url = $state.href('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
        $window.open(url,'_blank');
    }

     function onEnviarAdminsChange()
    {
      EntitatFactory.update_all_users($stateParams.idEntitat, vm.entitat.tipusnotificacions.id).then(function (response){

          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });
            
      }


  }
}());
